import {
  setPumpInputDetails,
  setPumpPressureShaft,
  setPumpInputCalculated,
  setPumpFreeGasWarning,
  setPumpModelE1,
  setEquipmentsForPumps,
  setSelectedPump,
  setPumpCalculationComplete,
  setBOHEquipments,
  setFetchEquipments,
  setFilteredEquipments,
  setESPEquipmentsForBOH,
  setESPEquipmentsForPumps,
  setPumpRequiredTDH,
  setPumpDesiredStage,
  fetchPumpData,
  setPumpOverrideCorrectionFactors,
  setPumpCompositeOverrideCorrectionFactors,
  loadPumpHiddenShaftType,
} from "../../../../src/store/calculation/calculation-output/pumpSlice";
import { useAppDispatch } from "../../../store/hooks/StoreHooks";
import {
  setHiddenPumpId,
} from "../../../store/calculation/calculation-input/TubingSlice";
import { useCallback } from "react";
import { setSurfaceCalculationComplete } from "../../../store/calculation/calculation-output/surfaceEquipmentSlice";

export const usePumpFacade = () => {
  const dispatch = useAppDispatch();
  const loadPumpData = async (payload: any) => {
    return await dispatch(fetchPumpData(payload));
  };

  const setPumpInput = (payload: any) => {
    return dispatch(setPumpInputDetails(payload));
  };

  const updatePumpReqdTDH = (payload: any): any => {
    dispatch(setSurfaceCalculationComplete(false));
    dispatch(setPumpRequiredTDH(payload));
  };


  const GetPumpEquipments = useCallback(() => {
    return dispatch(setFetchEquipments());
  }, []);

  const updateHiddenPumpId = (payload: any) => {
    dispatch(setSurfaceCalculationComplete(false));
    dispatch(setHiddenPumpId(payload));
  };

  const updateSelectedPump = (payload: any) => {
    return dispatch(setSelectedPump(payload));
  };

  const updatePumpDesrdStges = (payload: number) => {
    dispatch(setSurfaceCalculationComplete(false));
    dispatch(setPumpDesiredStage(payload));
  };

  const updateESPEquipmentsForPumps = (payload: any) => {
    return dispatch(setESPEquipmentsForPumps(payload));
  };

  const updateFilteredEquipments = (payload: any) => {
    return dispatch(setFilteredEquipments(payload)); 
  };

  const updateESPEquipmentsForBOH = (payload: any) => {
    return dispatch(setESPEquipmentsForBOH(payload));
  };
  
  const OverrideCorrectionFactors = (payload: any) => {
    return dispatch(setPumpOverrideCorrectionFactors(payload));
  };
  
  const overrideCorrectionFactorsCompositeCurve = (payload: any) => {
    return dispatch(setPumpCompositeOverrideCorrectionFactors(payload));
  };

  const triggerShaftTypeForPump = () => {
    return dispatch(loadPumpHiddenShaftType());
  }

  //todo
  // const setPumpPressureShaft = (payload: any) => {
  //     return dispatch(setPumpPressureShaft(payload));
  // };

  // const setPumpInputCalculated = (payload: any) => {
  //     return dispatch(setPumpInputCalculated(payload));
  // };

  // const setPumpFreeGasWarning = (payload: boolean) => {
  //     return dispatch(setPumpFreeGasWarning(payload));
  // };

  // const setPumpChartData = (chart1: any, chart2: any, chart3: any) => {
  //   return dispatch(setPumpChart1Data([chart1, chart2, chart3]));
  // };
  //todo
  // const setPumpModelE1 = (payload: any) => {
  //     return dispatch(setPumpModelE1(payload));
  // };

  // const setPumpList = (payload: any[]): any => {
  //   return dispatch(setPumpList(payload));
  // };

  // const setEquipmentsForPumps = (payload: any[]) => {
  //     return dispatch(setEquipmentsForPumps(payload));
  // };

  // const setSelectedPump = (payload: any) => {
  //     return dispatch(setSelectedPump(payload));
  // };

  // const setPumpCalculationComplete = (payload: boolean) => {
  //     return dispatch(setPumpCalculationComplete(payload));
  // };

  // const setBOHEquipments = (payload: any[]) => {
  //     return dispatch(setBOHEquipments(payload));
  // };

  // const getPumpState = () => {
  //     return getState().pump;
  // };

  return {
    GetPumpEquipments,
    loadPumpData,
    setPumpInput,
    // setPumpList,
    updatePumpReqdTDH,
    setPumpPressureShaft,
    setPumpInputCalculated,
    setPumpFreeGasWarning,
    setPumpModelE1,
    setEquipmentsForPumps,
    setSelectedPump,
    setPumpCalculationComplete,
    setBOHEquipments,
    updateFilteredEquipments,
    // setPumpChartData,
    updateHiddenPumpId,
    updateSelectedPump,
    updatePumpDesrdStges,
    updateESPEquipmentsForPumps,
    updateESPEquipmentsForBOH,
    OverrideCorrectionFactors,
    overrideCorrectionFactorsCompositeCurve,
    triggerShaftTypeForPump
  };
};
